import React, {useEffect, useState} from "react";
import {DEFAULT_FUND_SOURCE_FILTER, diff, inList, remove, search2, sort, STRICT} from "../canopia/CanopiaUtils";
import {FormGroup} from "react-bootstrap";
import FundTooltip from "../canopia/FundTooltip";
import LookthroughDate from "../canopia/LookthroughDate";
import {PageSelector} from "../core/PageSelector";
import HSort from "../canopia/HSort";
import NameTruncWithSearch from "../canopia/NameTruncWithSearch";
import Button from "react-bootstrap/Button";
import {TiDeleteOutline} from "react-icons/ti";
import FundCompositionAccess from "./FundCompositionAccess";
import FlatMultiSelect from "../canopia/FlatMultiSelect";
import Btn from "../canopia/Btn";
import Modal from "react-bootstrap/Modal";
import AdminService from "../../services/admin.service";
import ajaxloader from "../../images/ajax-loader.gif";
import {FaCheck} from "react-icons/fa";
import {RxCross2} from "react-icons/rx";

export default function FundList(props) {

    const tgtDataOrig = props.compositions;
    const clientConfig = props.clientConfig;
    const date = props.date;

    let levelEnum = [];
    let levels = [];
    let accessToAsk = [];
    let accessToAmDb = false;
    if (tgtDataOrig && tgtDataOrig.length > 0) {
        tgtDataOrig.forEach(fundAuths => {
            let level = fundAuths.level;
            if (!levels.includes(level)) {
                levels.push(level);
                levelEnum.push({key: level, label: level});
            }
            const def = fundAuths.defaultSourceFilter;
            if (def) {
                if (def.amLookthroughAccess === 1) {
                    accessToAmDb = true;
                }
                if (def.amAccessType === 'NDA' && def.ndaAccess === 0) {
                    accessToAsk.push(fundAuths);
                }
            }
        });
    }
    levelEnum.sort((a, b) => a.key - b.key);

    const borderLeft = 'border-left';

    // Pagination
    const PAGE_SIZE = 50;
    const [page, setPage] = useState(1);

    // Search
    const [clearSearchVisibility, setClearSearchVisibility] = useState('hidden');
    const [searchString, setSearchString] = useState('');

    // Filter
    const [showOutdatedOnly, setShowOutdatedOnly] = useState(false);
    const [showDiff, setShowDiff] = useState(false);
    const [selectedLevels, setSelectedLevels] = useState([{key: 1, label: 1}]);

    // Requests
    const [loading, setLoading] = useState(false);
    const [issues, setIssues] = useState(null);
    const [showAccessModal, setShowAccessModal] = useState(false);
    const [saveMessages, setSaveMessages] = useState(null);

    const initialSortStatus = {
        "posId": "asc",
        "name": "desc",
        "isin": "desc",
        "assetType": "desc",
        "weight": "asc",
        "fundLookup.specialRating": "desc",
        "fundLookup.fundRequest.fund.lipperStatus": "desc",
        "fundLookup.fundRequest.status": "desc",
        "currentSourceFilter.dateFmt": "desc", // default sort
        // "currentSourceFilter.source.label": "desc",
        "currentSourceFilter.amName": "desc",
        "defaultSourceFilter.dateFmt": "asc",
        // "defaultSourceFilter.source.label": "desc",
        "defaultSourceFilter.amName": "desc"
    }

    const SEARCH_PROPS = [
        "name",
        "isin",
        "assetType",
        "fundLookup.specialRating",
        "fundLookup.fundRequest.status",
        "fundLookup.fundRequest.fund.lipperStatus",
        "currentSourceFilter.amName",
        "defaultSourceFilter.amName"
        // "currentSourceFilter.source.label",
        // "defaultSourceFilter.source.label"
    ];

    const sortAndFilterInitialState = {
        sortStatus: initialSortStatus,
        sortCol: "posId",
    }

    const [myState, setMyState] = useState({
        tgtData: tgtDataOrig, // The displayed ones, filtered, sorted, ...

        ...sortAndFilterInitialState
    });

    const colSizeXL = 200;
    const colWidthXL = colSizeXL + 'px';
    const colSizeL = 122;
    const colWidthL = colSizeL + 'px';
    const colSizeM = 82;
    const colWidthM = colSizeM + 'px';
    const colSizeS = 55;
    const colWidthS = colSizeS + 'px';
    const padding = '0.55em 0.5em';

    useEffect(() => {
        // sortFunc(myState.sortCol);
        filter(selectedLevels, showDiff, showOutdatedOnly, searchString);
    }, []);

    function changePage(page) {
        setPage(page.key);
    }

    function sortFunc(colName) {
        const newState = sort({...myState}, colName, initialSortStatus);
        setMyState(newState);
    }

    function handleShowOutdated(show) {
        filter(selectedLevels, showDiff, show, searchString);
        setShowOutdatedOnly(show);
    }

    function handleShowDifferentSourceOnly(show) {
        filter(selectedLevels, show, showOutdatedOnly, searchString);
        setShowDiff(show);
    }

    function filter(selectedLevels, showDiff, showOutdatedOnly, searchString) {
        let newData = [...tgtDataOrig];

        if (selectedLevels.length < levelEnum.length) {
            newData = inList(selectedLevels.map(option => option.key), newData, ["level"], STRICT);
        }

        if (showOutdatedOnly) {
            newData = remove(date, newData, ["currentSourceFilter.dateFmt"]);
        }

        if (showDiff) {
            newData = diff(newData,
                ["currentSourceFilter.dateFmt", "currentSourceFilter.amName"],
                ["defaultSourceFilter.dateFmt", "defaultSourceFilter.amName"]
            );
        }

        if (searchString.trim() === "") {
            setClearSearchVisibility("hidden");
        } else {
            if (clearSearchVisibility === "hidden") {
                setClearSearchVisibility("visible");
            }
            newData = search2(searchString, newData, SEARCH_PROPS);
        }

        let newState = {...myState, tgtData: newData};

        newState = sort(newState, newState.sortCol, initialSortStatus, true);

        setMyState(newState);
    }

    // Search category, the component is common to the global and histo view
    const searchCategory = (e) => {
        let searchString = e.target.value;
        searchCat(searchString);
    }

    const resetSearch = () => {
        searchCat('');
    }

    function searchCat(searchString) {
        setSearchString(searchString);
        filter(selectedLevels, showDiff, showOutdatedOnly, searchString);
    }

    function changeSelectedLevels(tgtElem) {
        let tgtSelectedLevels = [...selectedLevels];
        let indexOf = selectedLevels.findIndex(elem => tgtElem.key === elem.key);
        if (indexOf > -1) {
            if (selectedLevels.length <= 1) {
                // Cannot unselect the last one
                return;
            }
            tgtSelectedLevels.splice(indexOf, 1);
        } else {
            tgtSelectedLevels.push(tgtElem);
        }
        setSelectedLevels(tgtSelectedLevels);
        filter(tgtSelectedLevels, showDiff, showOutdatedOnly, searchString);
    }

    function handleShowAccessModal() {
        setShowAccessModal(true);
        getAccessRequest();
    }

    function hideAccessModal() {
        setShowAccessModal(false);
        setIssues(null);
        setSaveMessages(null);
    }

    function getAccessRequest() {

        setLoading(true);

        AdminService.getLookthroughAccessRequest({
            clientId: clientConfig.clientWrapper.id,
            dateStr: date
        }).then(response => {
                setIssues(response.data ? response.data.data : null);
                setLoading(false);
            },
            error => {
                setLoading(false);
                // processError(error);
            }
        );
    }

    function sendAccessRequest() {
        setLoading(true);

        let accessCsv = accessToAsk.map(a => a.defaultSourceFilter.amName + ': ' + a.name + ' (' + a.isin + ')');
        AdminService.sendLookthroughAccessRequest({
            clientId: clientConfig.clientWrapper.id,
            dateStr: date,
            addAmGlobalAccess: !accessToAmDb,
            lookthroughs: accessCsv
        }).then(response => {
                setLoading(false);
                const respData = response.data;
                if (respData) {
                    const messages = respData.data;
                    setSaveMessages(messages);
                } else {
                    setSaveMessages(null);
                }
            },
            error => {
                setLoading(false);
                // processError(error);
            }
        );
    }

    let searchCategoryInput = <FormGroup controlId="selectView">
        <input value={searchString}
               placeholder="Search fund, source, class..."
               className={'form-control float-left'}
               style={{minWidth: "280px"}}
               aria-label="Search category"
               onChange={searchCategory}
               aria-describedby="basic-addon2"/>
    </FormGroup>;

    let searchCategoryComp;
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    if (isIE) {
        searchCategoryComp =
            <div style={{display: "flex", flexWrap: "nowrap", marginRight: 'auto'}}>
                {searchCategoryInput}
            </div>
    } else {
        searchCategoryComp = <div style={{display: "flex", flexWrap: "nowrap"}}>
            {searchCategoryInput}
            <Button variant="light" size="sm"
                    style={{
                        marginLeft: 0,
                        padding: 4,
                        borderWidth: '1px 1px 1px 0',
                        borderColor: '#ced4da',
                        borderRadius: '0.25rem .25rem .25rem 0.25rem',
                        visibility: clearSearchVisibility
                    }}
                    onClick={resetSearch}>
                <TiDeleteOutline size={"1.4em"} className={"canopia2"}/>
            </Button>
            {/*<span style={{paddingLeft: '10px', margin: 'auto'}}>{searchString.length > 0 ? searchCount + ' result(s)' : ''}</span>*/}
        </div>
    }

    // GC (last level)
    let rows;
    let effPage = page;
    let tgtData = myState.tgtData;
    if (tgtData && tgtData.length > 0) {

        let startIndex = (effPage - 1) * PAGE_SIZE;
        if (startIndex >= tgtData.length) {
            effPage = 1;
            startIndex = (effPage - 1) * PAGE_SIZE;
        }
        const tgtDataAtPage = tgtData.slice(startIndex, startIndex + PAGE_SIZE);

        rows = tgtDataAtPage.map(fundAuths => {
            const cur = fundAuths.currentSourceFilter;
            const def = fundAuths.defaultSourceFilter;
            const noData = "-";

            const accessDetail = <FundCompositionAccess sourceFilter={def} noData={noData}/>

            return <div key={fundAuths.posId} className={"flex-nowrap border-top"}>
                <div className={"setup-col right"} style={{flexBasis: colWidthS, padding: padding}}>
                    {fundAuths.posId}
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthXL, padding: padding}}>
                    <NameTruncWithSearch name={fundAuths.name} maxSize={80} search={searchString} wrap={true}/>
                    {fundAuths.occ && fundAuths.occ > 1 &&
                        <div className={'gc-duplicates'} style={{marginLeft: '0.5em'}}>
                            <abbr title={'Appears many times'}>+</abbr>
                        </div>}
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={fundAuths.isin} maxSize={50} search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={fundAuths.assetType} maxSize={50} search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col right"} style={{flexBasis: colWidthM, padding: padding}}>
                    {fundAuths.level === 1 && fundAuths.weightFmt}
                    {/*{fundAuths.weightFmt}*/}
                </div>
                <div className={"setup-col right"} style={{flexBasis: colWidthM, padding: padding}}>
                    {fundAuths.fundLookup.fundRequest ?
                        <NameTruncWithSearch name={fundAuths.fundLookup.fundRequest.fund.lipperStatus} maxSize={50}
                                             search={searchString}
                                             wrap={true}/> : noData}
                </div>
                <div className={"setup-col right"} style={{flexBasis: colWidthS, padding: padding}}>
                    {fundAuths.level}
                </div>

                {/* Current */}
                <div className={"setup-col " + borderLeft} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={fundAuths.fundLookup.specialRating} maxSize={50} search={searchString}
                                         wrap={true}/>
                </div>
                <div className={"setup-col"}
                     style={{flexBasis: colWidthL, padding: padding}}>
                    {cur ? <FundTooltip fundAuth={cur}/> : noData}
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthM, padding: padding}}>
                    {cur ? <LookthroughDate status={cur.lookthroughStatus}
                                            dateFormatted={cur.dateFmt}/> : noData}
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    {cur ? <NameTruncWithSearch name={cur.amName} maxSize={50} search={searchString}
                                                wrap={true}/> : noData}
                </div>

                {/* default */}
                <div className={"setup-col " + borderLeft}
                     style={{flexBasis: colWidthL, padding: padding}}>
                    {def ? <FundTooltip fundAuth={def}/> : noData}
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthM, padding: padding}}>
                    {def ? <LookthroughDate status={def.lookthroughStatus}
                                            dateFormatted={def.dateFmt}/> : noData}
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    {def ? <NameTruncWithSearch name={def.amName} maxSize={50} search={searchString}
                                                wrap={true}/> : noData}
                </div>
                <div className={"flex-00"} style={{flexBasis: colWidthM, padding: padding}}>
                    {accessDetail}
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    {fundAuths.fundLookup.fundRequest ?
                        <NameTruncWithSearch name={fundAuths.fundLookup.fundRequest.status} maxSize={50}
                                             search={searchString} wrap={true}/>
                        : noData}
                </div>
            </div>
        });
    }

    const pageSelector = <PageSelector page={effPage} pageSize={PAGE_SIZE} size={tgtData.length}
                                       clickFunc={changePage}/>;

    return <>
        <div className={'border-top background-light'} style={{marginTop: "2rem"}}>
            <div className={"flex-nowrap"}>
                <div className={"setup-th"} style={{flexBasis: (colSizeS + colSizeXL) + "px"}}>
                    {pageSelector}
                </div>
                <div className={"setup-th-input"} style={{flexBasis: colWidthXL}}>
                    <div>{searchCategoryComp}</div>
                </div>
                <div className={"setup-th"}>
                    <Btn label={'Outdated Only'}
                         curClass={showOutdatedOnly ? 'canopia-nav-btn-active' : 'canopia-nav-btn'}
                         clickFunction={handleShowOutdated}
                         btnValue={showOutdatedOnly}
                         doNotTranslate={true}/>
                </div>
                <div className={"setup-th"}>
                    <Btn label={'Different Only'}
                         curClass={showDiff ? 'canopia-nav-btn-active' : 'canopia-nav-btn'}
                         clickFunction={handleShowDifferentSourceOnly}
                         btnValue={showDiff}
                         doNotTranslate={true}/>
                </div>
                <div className={"setup-th"}>
                    <Btn label={'Request access'}
                         curClass={'canopia-btn-active'}
                         clickFunction={handleShowAccessModal}
                         btnValue={showOutdatedOnly}
                         doNotTranslate={true}/>
                </div>
            </div>
        </div>
        <div className={'border-top background-light'}>
            <div className={"flex-nowrap"}>
                <div className={"setup-th"} style={{flexBasis: (colSizeS + colSizeXL) + "px"}}>
                    Funds
                </div>
                <div className={"setup-th right"} style={{flexBasis: (2 * colSizeL + colSizeM + colSizeS) + "px"}}>
                    Levels <FlatMultiSelect enums={levelEnum}
                                            curValues={selectedLevels}
                                            curClass={'canopia-nav-btn-active'}
                                            otherClass={'canopia-nav-btn'}
                                            clickFunction={changeSelectedLevels}
                                            clickParamFromEnum={true}
                                            doNotTranslate={true}/>
                </div>
                <div className={"setup-th"} style={{flexBasis: colWidthM}}></div>
                <div className={"setup-th " + borderLeft}
                     style={{flexBasis: 3 * colSizeL + colSizeM + "px"}}>
                    Current ({clientConfig.fundSourceFilterCsv})
                </div>
                <div className={"setup-th " + borderLeft} style={{flexBasis: 2 * colSizeL +  2 * colWidthM + "px"}}>
                    {DEFAULT_FUND_SOURCE_FILTER}
                </div>
            </div>
        </div>

        <div className={'border-top background-light'}>
            <div className={"flex-nowrap"}>
                <div className={"setup-th"} style={{flexBasis: colWidthS}}>
                    <HSort label={<b>Id</b>} colName={'posId'} state={myState} sortFunc={sortFunc}/>
                </div>
                <div className={"setup-th"} style={{flexBasis: colWidthXL}}>
                    <HSort label={<b>Name</b>} colName={'name'} state={myState} sortFunc={sortFunc}/>
                </div>
                <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                    <HSort label={<b>ISIN</b>} colName={'isin'} state={myState} sortFunc={sortFunc}/>
                </div>
                <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                    <HSort label={<b>Asset Type</b>} colName={'assetType'} state={myState} sortFunc={sortFunc}/>
                </div>
                <div className={"setup-th"} style={{flexBasis: colWidthM}}>
                    <HSort label={<b>Weight</b>} colName={'weight'} state={myState} sortFunc={sortFunc}/>
                </div>
                <div className={"setup-th"} style={{flexBasis: colWidthM}}>
                    <HSort label={<b>Status</b>} colName={'fundLookup.fundRequest.fund.lipperStatus'}
                           state={myState} sortFunc={sortFunc} showLegend={true}/>
                </div>
                <div className={"setup-th"} style={{flexBasis: colWidthS}}>
                    <HSort label={<b>Lvl</b>} colName={'level'} state={myState} sortFunc={sortFunc} showLegend={true}/>
                </div>

                {/* Current */}
                <div className={"setup-th " + borderLeft} style={{flexBasis: colWidthL}}>
                    <HSort label={<b>Spec. Hand.</b>} colName={'fundLookup.specialRating'} state={myState}
                           sortFunc={sortFunc}
                           showLegend={true}/>
                </div>
                <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                    <b>Fund ISIN</b>
                </div>
                <div className={"setup-th"} style={{flexBasis: colWidthM}}>
                    <HSort label={<b>Date</b>} colName={'currentSourceFilter.dateFmt'} state={myState}
                           sortFunc={sortFunc}/>
                </div>
                <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                    <HSort label={<b>AM</b>} colName={'currentSourceFilter.amName'} state={myState}
                           sortFunc={sortFunc}/>
                </div>

                {/* Default */}
                <div className={"setup-th " + borderLeft} style={{flexBasis: colWidthL}}>
                    <b>Fund ISIN</b>
                </div>
                <div className={"setup-th"} style={{flexBasis: colWidthM}}>
                    <HSort label={<b>Date</b>} colName={'defaultSourceFilter.dateFmt'} state={myState}
                           sortFunc={sortFunc}/>
                </div>
                <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                    <HSort label={<b>AM</b>} colName={'defaultSourceFilter.amName'} state={myState}
                           sortFunc={sortFunc}/>
                </div>
                <div className={"setup-th"} style={{flexBasis: colWidthM}}><b>Access</b></div>
                <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                    <HSort label={<b>Look-through</b>} colName={'fundLookup.fundRequest.status'} state={myState}
                           sortFunc={sortFunc} showLegend={true}/>
                </div>
            </div>
        </div>
        {rows}
        <Modal
            show={showAccessModal}
            onHide={() => hideAccessModal()}
            backdrop="static"
            keyboard={false}
            size={"lg"}
            aria-labelledby="terms-and-conditions"
            scrollable={true}
        >
            <Modal.Body>
                {loading ? <div style={{margin: "1rem auto"}}>
                        <img alt="loading" src={ajaxloader}/>
                    </div> :
                    <div className={"alert"}>
                        {issues && issues.length > 0 &&
                            <div className={"alert alert-info"} style={{marginBottom: "1rem"}}>
                                {issues.map(issue => {
                                    return <div className={"setup-col"}
                                                style={{flexBasis: colWidthXL, padding: padding}}>
                                        A request is already open for this client (created
                                        on {issue.createdOnFmt} by {issue.author}, assigned to {issue.assignee})
                                    </div>
                                })}
                            </div>
                        }
                        <div style={{marginTop: '20px'}}>
                            <h3 className={'canopia2'}>Access Request</h3>
                        </div>
                        <p>
                            Find below the missing access. Click on "Send Request" to ask for authorization
                        </p>
                        <div style={{marginTop: '20px'}}>
                            <h4 className={'canopia'}>Global AM Access</h4>
                        </div>
                        {accessToAmDb ?
                            <>The access to the AM database is already granted <FaCheck color={'green'}/></>
                            : <>The access to the AM database is not granted <RxCross2 color={'red'}/></>
                        }
                        <div style={{marginTop: '20px'}}>
                            <h4 className={'canopia'}>Specific AM Access</h4>
                        </div>
                        {accessToAsk.length === 0 ? <>All AMs are authorized <FaCheck
                            color={'green'}/></> : <div className={' modal-scroll'}>
                            {accessToAsk.map(fundAuths => {
                                return <div className={"flex-nowrap border-top"}>
                                    <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                                        {fundAuths.defaultSourceFilter.amName}
                                    </div>
                                    <div className={"setup-col"} style={{flexBasis: colWidthXL, padding: padding}}>
                                        {fundAuths.name}
                                    </div>
                                    <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                                        {fundAuths.isin}
                                    </div>
                                    <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                                        {fundAuths.assetType}
                                    </div>
                                </div>
                            })}
                        </div>}
                    </div>
                }
                {saveMessages && (
                    <div className="form-group">
                        <br/>
                        <h5>Summary:</h5>
                        <div className={"alert import_log"}>
                            {saveMessages.map(message => {
                                return <><span
                                    className={"import_log_" + message.key}>{message.value}</span><br/></>
                            })}
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => hideAccessModal()}>
                    {saveMessages ? 'Close' : 'Cancel'}
                </Button>
                {!saveMessages &&
                    <Button variant="primary" onClick={() => sendAccessRequest()}
                            disabled={loading || (issues && issues.length > 0) || (accessToAmDb && accessToAsk.length === 0)}>
                        Send request
                    </Button>}
            </Modal.Footer>
        </Modal>
    </>;
}